export default function TypographyPage() {
  const sampleText =
    'The quick brown fox jumps over the lazy dog. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.';

  const sections = [
    {
      title: 'Headings',
      description:
        'Headings are best-suited for short, high-emphasis text on smaller screens. These styles can be good for marking primary passages of text or important regions of content.',
      classes: ['heading-lg', 'heading-md', 'heading-sm'],
      sample: sampleText,
    },
    {
      title: 'Subheadings',
      description:
        'Subheadings are smaller than heading styles, and should be used for medium-emphasis text that remains relatively short. For example, consider using subheading styles to divide secondary passages of text or secondary regions of content.',
      classes: ['subheading-lg', 'subheading-md', 'subheading-sm'],
      sample: sampleText,
    },
    {
      title: 'Body',
      description:
        'Body text is used for longer passages of text and is typically the main content of a page.',
      classes: ['body-lg', 'body-md', 'body-sm'],
      sample: sampleText,
    },
    {
      title: 'Labels',
      description:
        'Label styles are smaller, utilitarian styles, used for things like the text inside components or for very small text in the content body, such as captions, Buttons, form field labels, etc.',
      classes: ['label-lg', 'label-md', 'label-sm'],
      sample: sampleText,
    },
  ];

  return (
    <div className="mx-auto max-w-7xl p-8">
      <h1 className="mb-8 text-3xl font-bold">Typography System</h1>

      <div className="mb-4 grid grid-cols-[150px_1fr] gap-8 border-b pb-2 font-bold text-on-surface-variant">
        <div>Class</div>
        <div>Sample</div>
      </div>

      <div className="space-y-8">
        {sections.map((section) => (
          <section key={section.title}>
            <div className="mb-4 grid grid-cols-[150px_1fr] gap-8 border-b border-outline-variant pb-2">
              <div className="col-span-2">
                <h2 className="text-xl font-semibold tracking-wider text-on-surface-variant uppercase">
                  {section.title}
                </h2>
                <p className="mt-1 text-xs font-normal text-on-surface-variant normal-case">
                  {section.description}
                </p>
              </div>
            </div>
            <div className="space-y-4">
              {section.classes.map((className) => (
                <div
                  key={className}
                  className="grid grid-cols-[150px_1fr] items-baseline gap-4"
                >
                  <div className="sticky top-4 rounded bg-surface-container-low p-1 font-mono text-xs text-on-surface-variant">
                    .{className}
                  </div>

                  <div className={className}>{section.sample}</div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
